import { Footer } from "../../footer/Footer";
import { TopMenu } from "../../top-menu/TopMenu";
import { Hero } from "../../home-sections/Hero";
import { TrustBar } from "../../home-sections/TrustBar";
import { ServicesSection } from "../../home-sections/Services";
import { FeaturedProjects } from "../../home-sections/FeaturedProjects";
import { WhyUs } from "../../home-sections/WhyUs";
import { QuoteCTA } from "../../home-sections/QuoteCTA";

export const HomeWrapper = () => (
    <div className="min-h-screen flex flex-col bg-white">
        <TopMenu />
        <main className="flex-1">
            <Hero />
            <TrustBar />
            <ServicesSection />
            <FeaturedProjects />
            <WhyUs />
            <QuoteCTA />
        </main>
        <Footer />
    </div>
);
